import { useCopilotTool } from '@customerio/hydra-copilot/react';
import { z } from 'zod';
import zodToJsonSchema from 'zod-to-json-schema';
import { useAnalytics } from '@/services/analytics';
import { useCustomerFeedback } from '@/features/customer-feedback';

export function ShowFeedbackTool() {
  const showFeedbackModal = useCustomerFeedback();
  const analytics = useAnalytics();

  useCopilotTool({
    type: 'client',
    name: 'show_feedback_form',
    description: `
      Shows a feedback form for the user to provide feedback or to request a feature. If at any point the user asks for feedback or requests a feature, you should show the feedback form.

      <sample-chat>
      User: I want to give feedback on this experience
      Model: show_feedback_form({ feedback: "INSERT A SUMMARY OF THE CHAT HERE", })
      </sample-chat>

      If the user asks for you to do something that you are 100% sure you cannot do, you should also show the feedback form.

      <sample-chat>
      User: I want to create a campaign.
      Model: I am unable to create a new campaign for you, but I can help you with other tasks. Do you want to request that feature?
      User: Yes
      Model: show_feedback_form({ feedback: "I want to create a new campaign but the Assistant is not helping me." })
      </sample-chat>
    `,
    requestSchema: zodToJsonSchema(
      z.object({
        feedback: z
          .string()
          .describe(
            'The summary of the feedback provided by the user, written in first person (e.g., "I need help with..." or "I would like..."). You should do your best to figure out what the user wants to say.',
          ),
      }),
    ),
    handler({ args }) {
      void showFeedbackModal({
        feature: 'AI Assistant',
        initialFeedback: args.feedback,
        onSubmit: (values) => {
          analytics.track('aiAssistant', 'feedbackFormSubmitted', {
            Feedback: values.feedback,
          });
        },
      });
      return true;
    },
  });

  return null;
}
